/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pre_Replace_Dialog_TitleInputs */



/**
* | output |
* | --- |
* | "Pre-replacement" |
*
* @param {Pre_Replace_Dialog_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const pre_replace_dialog_title = /** @type {((inputs?: Pre_Replace_Dialog_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pre_Replace_Dialog_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Pre-replacement")
	return /** @type {LocalizedString} */ ("Pré-remplacement")
});